import { render, staticRenderFns } from "./AddMinimumQuantity.vue?vue&type=template&id=181ef8a6&scoped=true&"
import script from "./AddMinimumQuantity.vue?vue&type=script&lang=js&"
export * from "./AddMinimumQuantity.vue?vue&type=script&lang=js&"
import style0 from "./AddMinimumQuantity.vue?vue&type=style&index=0&id=181ef8a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181ef8a6",
  null
  
)

export default component.exports